import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadOwnerProfile, logoutOwner } from '@main/features/auth/ownerAuthSlice';
import { AppShellBrand } from '@shared/components/AppShellBrand';
import { ThemeToggle } from '@shared/components/ThemeToggle';

export function ProfileLayout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { profile, status } = useSelector((s) => s.ownerAuth);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const menuItems = [
    { to: '/profile', label: 'Профиль', end: true },
    { to: '/profile/branches', label: 'Филиалы' },
    { to: '/profile/events', label: 'События' },
    { to: '/profile/expenses', label: 'Общие расходы' },
    { to: '/profile/settings', label: 'Настройки' },
  ];

  useEffect(() => {
    if (!profile && status === 'authenticated') {
      dispatch(loadOwnerProfile());
    }
  }, [dispatch, profile, status]);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!mobileMenuOpen) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setMobileMenuOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [mobileMenuOpen]);

  const onLogout = async () => {
    setMobileMenuOpen(false);
    await dispatch(logoutOwner());
    navigate('/');
  };

  return (
    <div className="app-shell">
      <header className="app-shell__header">
        <AppShellBrand>AG.platform</AppShellBrand>
        <nav className="app-shell__nav">
          {menuItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end}>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="app-shell__spacer" />
        {profile?.email && <span className="app-shell__user-email">{profile.email}</span>}
        <ThemeToggle />
        <button className="app-shell__logout" onClick={onLogout} type="button">
          Выйти
        </button>
        <button
          type="button"
          className="app-shell__mobile-burger"
          aria-label="Открыть меню"
          aria-expanded={mobileMenuOpen}
          onClick={() => setMobileMenuOpen(true)}
        >
          <span />
          <span />
          <span />
        </button>
      </header>
      {mobileMenuOpen && (
        <div
          className="mobile-menu-backdrop"
          role="presentation"
          onClick={() => setMobileMenuOpen(false)}
        >
          <aside
            className="mobile-menu"
            aria-label="Меню кабинета"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="mobile-menu__header">
              <div className="mobile-menu__title">Меню</div>
              <button
                type="button"
                className="mobile-menu__close"
                aria-label="Закрыть меню"
                onClick={() => setMobileMenuOpen(false)}
              >
                ×
              </button>
            </div>
            {profile?.email && <div className="mobile-menu__email">{profile.email}</div>}
            <nav className="mobile-menu__nav">
              {menuItems.map((item) => (
                <NavLink key={item.to} to={item.to} end={item.end}>
                  {item.label}
                </NavLink>
              ))}
            </nav>
            <button className="mobile-menu__logout" onClick={onLogout} type="button">
              Выйти
            </button>
          </aside>
        </div>
      )}
      <main className="app-shell__main">
        <Outlet />
      </main>
    </div>
  );
}
